<template>
  <v-container class="pt-4">
    <div class="text-center mb-6">
      <h1 class="mb-0"><span>🏗️</span>{{ $t('rollOffWizard.projectType.title') }}</h1>
      <p class="mb-0">{{ $t('rollOffWizard.projectType.subtitle') }}</p>
    </div>
    <v-row class="mb-8" align="stretch" justify="center">
      <v-col
        v-for="option in options"
        :key="option.value"
        cols="12"
        md="4"
        lg="3"
        class="d-flex justify-center"        
      >
        <v-card
          outlined
          flat
          class="border-2-point-5"
          :class="['rounded-lg', 'pa-6', 'text-left', 'w-100', 'd-flex', 'flex-column', 'align-start', selected === option.value ? 'border-primary' : 'border', 'option-card']"
          :style="selected === option.value ? 'border-color:#0b6f52' : ''"
          @click="select(option.value)"
        >
          <div style="position:absolute;top:18px;right:18px;">
            <v-icon v-if="selected === option.value" color="success">mdi-radiobox-marked</v-icon>
            <v-icon v-else color="#bdbdbd">mdi-radiobox-blank</v-icon>
          </div>

          <v-img :src="option.img" class="no-drag mx-auto mb-4" style="width:180px;height:180px;" :alt="$t(option.title)" />
          <div class="font-weight-bold mb-2" style="font-size:1.15rem;line-height: 1.3rem;">{{ $t(option.title) }}</div>
          <div class="mb-4" style="color:#444;min-height:48px;line-height: 1.3rem;">{{ $t(option.desc) }}</div>
          <div class="d-flex align-center mb-2 mt-auto" style="font-size:1.02rem;font-weight:500;">
            ⏰
            <span class="secondary--text">{{ $t(option.duration) }}</span>
          </div>
          
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, inject } from 'vue'
import { useRollOffWizardStore } from '@/store/rollOffWizard'

const wizardStore = useRollOffWizardStore()

const selected = ref(wizardStore.projectType)
const onContinue = inject('onContinue')

const options = [
  { value: 'short-term', title: 'rollOffWizard.projectType.shortTerm.title', desc: 'rollOffWizard.projectType.shortTerm.desc', duration: 'rollOffWizard.projectType.shortTerm.duration', img: 'https://embed.wasteconnections.com/images-widget/roll-off-wizard/Step2/remodeling.png' },
  { value: 'long-term', title: 'rollOffWizard.projectType.longTerm.title', desc: 'rollOffWizard.projectType.longTerm.desc', duration: 'rollOffWizard.projectType.longTerm.duration', img: 'https://embed.wasteconnections.com/images-widget/roll-off-wizard/Step2/construction-site.png' },
  { value: 'recurring', title: 'rollOffWizard.projectType.recurring.title', desc: 'rollOffWizard.projectType.recurring.desc', duration: 'rollOffWizard.projectType.recurring.duration', img: 'https://embed.wasteconnections.com/images-widget/roll-off-wizard/Step2/commercial-waste.png' }
]

function select(val) {
  if(!wizardStore.loading){
    wizardStore.loading = true
    selected.value = val
    wizardStore.setProjectType(val)
    wizardStore.resetAfterProjectType()
    if (onContinue) {
      setTimeout(() => {
        wizardStore.loading = false
        onContinue()
      }, 350)
    }
  }
}
</script>

<style scoped>
/* Only keep very specific tweaks if needed */
.option-card {
  cursor: pointer;
  min-height: 410px;
  border-radius: 16px;
  position: relative;
  transition: border 0.2s, box-shadow 0.2s;
}
.option-card:hover{
  border-color: #003F6F;
}
@media (max-width: 1100px) {
  .option-card {
    width: 95vw !important;
    min-width: 0;
    max-width: 400px;
  }
}
.no-drag{
  user-select: none; 
  user-drag: none;
  -webkit-user-drag: none;
  pointer-events: none;
}
</style>